import moment from 'moment';

const getNextBusinessDay = (date: Date) => {
  let nextDate = moment(date);

  // Verifica se é sábado (6) ou domingo (0)
  while (nextDate?.day() === 6 || nextDate?.day() === 0) {
    nextDate = nextDate.add(1, 'days');
  }

  return nextDate?.toDate();
};

export { getNextBusinessDay };
